module.exports = __webpack_public_path__ + "static/Crocciantino-(Rum-Krokant)-9402270fbbb243d6ea1640d391291cb3.png";